module.exports = __webpack_public_path__ + "static/media/nature.ec129900.jpg";